import React from 'react';
import PropTypes from 'prop-types';

const ReadOnly = props => {
  const handleClick = event => {
    event.cancelBubble = true;
    event.returnValue = false;
    event.stopPropagation();
    event.preventDefault();
  };

  return (
    <div className="readonly-overlay" onClick={handleClick}>
      {!props.hideIcon && (
        <div className="readonly-overlay-icon">
          <i className="zmdi zmdi-lock zmdi-hc-fw" />
        </div>
      )}
      {props.children}
    </div>
  );
};

ReadOnly.defaultProps = {
  hideIcon: false,
};

ReadOnly.propTypes = {
  hideIcon: PropTypes.bool,
  children: PropTypes.element.isRequired,
};

export default ReadOnly;
